import {
  LegislativnyMaterialHistoriaApi,
  StadiumMaterialuHistoria as StadiumMaterialuHistoriaGenerated,
  StadiumMaterialuHistoriaList as StadiumMaterialuHistoriaListGenerated,
  Organizacia as OrganizaciaGenerated,
} from 'evidencna-aplikacia-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import StadiumMaterialuHistoria from '../../../model/legislativnyMaterial/StadiumMaterialuHistoria';
import { mapStadium } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import StadiumMaterialuHistoriaList from '../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';
import Uuid from '../../../model/Uuid';
import Organizacia from '../../../model/ciselniky/Organizacia';

const client = new LegislativnyMaterialHistoriaApi(apiConfiguration(evidenciaPrefixPath));

const mapOrganizacia = (data: OrganizaciaGenerated): Organizacia => ({
  uuid: data.uuid,
  nazov: data.uplnyNazov,
  ldapUuid: data.ldapUuid,
  skratenyNazov: data.skratenyNazov,
});

const mapStadiumMaterialuHistoria = (data: StadiumMaterialuHistoriaGenerated): StadiumMaterialuHistoria => ({
  uuid: data.uuid,
  stadium: mapStadium(data.stadium),
  datumZacatia: data.datumZacatia ? new Date(data.datumZacatia) : null,
  datumUkoncenia: data.datumUkoncenia ? new Date(data.datumUkoncenia) : null,
  vlastnikAktivity: data.vlastnikAktivity ? mapOrganizacia(data.vlastnikAktivity) : null,
});

const map = (data: StadiumMaterialuHistoriaListGenerated): StadiumMaterialuHistoriaList => ({
  historiaRecords: data.historiaRecords.map(historiaRecord => mapStadiumMaterialuHistoria(historiaRecord)),
});

// eslint-disable-next-line import/prefer-default-export
export const fetchStadiumMaterialuHistoriaList = async (uuid: Uuid, headers?: object):
  Promise<ClientResponse<StadiumMaterialuHistoriaList>> => {
  if (uuid === null || uuid === '' || uuid === undefined) {
    return {
      data: null,
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getAllHistoriaRecords(uuid, headers);
  return {
    data: map(data),
    responseCode: status,
  };
};
